import { Component, OnInit } from '@angular/core';
import { ThemeSettingService } from '../services/theme-setting.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {

  loaderConfig:any;

  constructor(private themeSettingService: ThemeSettingService) { }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
  }

}
